module.exports = __webpack_public_path__ + "static/img/phongComputer.aa6d3ad9.png";